/*
--------------------------------------------------------------------------------------------------------------
Autor:              EMANUEL GUIVAR
Fecha de creacion:  09/04/2025
Sistema:            Web seguros 
Descripcion:        Obtener parametros de URL query string
BITACORA DE CAMBIOS 
--------------------------------------------------------------------------------------------------------------
CODIGO      REQ     ANALISTA                    FECHA       MOTIVO
--------------------------------------------------------------------------------------------------------------
*/
import { useLocation } from "react-router-dom";

const useUrlQuery = () => {
    const location = useLocation();
    return new URLSearchParams(location.search);
};

export default useUrlQuery;